import { Box, Button, HStack, IconButton, Text } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext.tsx';
import { AppLayoutToolbar } from '@src/components/sco/AppLayout/Toolbar/AppLayoutToolbar.tsx';
import { PitchDeckView } from '@src/components/sco/PitchDeckAuditor/model/types';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useEffect } from 'react';
import { LuChevronLeft, LuChevronRight, LuMessagesSquare } from 'react-icons/lu';
import { useBreakpointContext } from '../../utilities/BreakpointProvider';
export function PitchDeckToolbar({
  deck,
  activeSlideId,
  onSelectSlide,
  onDiscuss
}: {
  deck: PitchDeckView;
  activeSlideId: string | null;
  onSelectSlide: (pitchDeckSlideId: string | null) => void;
  onDiscuss: () => void;
}) {
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const activeContent = useActiveContentContext();
  const appLayout = useParentAppLayout();
  const slides = deck.slides;
  const activeIndex = activeSlideId ? slides.findIndex(s => s.pitchDeckSlideId === activeSlideId) : -1;
  const activeSlide = activeIndex >= 0 ? slides[activeIndex] : null;
  useEffect(() => {
    activeContent.setBreadcrumbs?.([activeSlide ? {
      title: `Slide ${activeSlide.position} · ${activeSlide.classificationLabel}`,
      href: '#'
    } : {
      title: 'Deck Overview',
      href: '#'
    }]);
    activeContent.setItem?.({
      id: `pitch-deck-${deck.pitchDeckId}`,
      title: deck.companyName
    });
    return () => {
      activeContent.setBreadcrumbs?.([]);
      activeContent.setItem?.(undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSlide?.pitchDeckSlideId, deck.pitchDeckId]);
  const goPrev = () => {
    if (activeIndex <= 0) {
      onSelectSlide(null);
    } else {
      onSelectSlide(slides[activeIndex - 1].pitchDeckSlideId);
    }
  };
  const goNext = () => {
    if (activeIndex < 0) {
      if (slides[0]) {
        onSelectSlide(slides[0].pitchDeckSlideId);
      }
    } else if (activeIndex < slides.length - 1) {
      onSelectSlide(slides[activeIndex + 1].pitchDeckSlideId);
    }
  };
  const prevDisabled = activeSlideId === null;
  const nextDisabled = slides.length === 0 || activeIndex >= 0 && activeIndex >= slides.length - 1;
  return <AppLayoutToolbar leftElements={<HStack align={'center'} flexGrow={1} gap={2} justify={'center'}>
          <IconButton aria-label={'Previous slide'} disabled={prevDisabled} size={'sm'} variant={'outline'} onClick={goPrev}>
            <LuChevronLeft />
          </IconButton>
          <Box>
            <Text color={'fg.muted'} minWidth={'3.5em'} textAlign={'center'} textStyle={'label2xs'} whiteSpace={'nowrap'}>
              {activeSlide ? `${activeSlide.position} / ${deck.slideCount}` : 'Overview'}
            </Text>
          </Box>
          <IconButton aria-label={'Next slide'} disabled={nextDisabled} size={'sm'} variant={'outline'} onClick={goNext}>
            <LuChevronRight />
          </IconButton>
        </HStack>} rightElements={<HStack display={isMobile ? 'none' : 'flex'} flexShrink={0} gap={3}>
          {!appLayout.isPanelOpen('*-aside') && <Button colorPalette={'purple'} size={'sm'} onClick={onDiscuss}>
              <LuMessagesSquare />
              {isMobile ? null : activeSlide ? 'Discuss This Slide' : 'Discuss'}
            </Button>}
        </HStack>} />;
}